module.exports = __webpack_public_path__ + "static/media/upLoad_icon.90f7b955.svg";